/* eslint-disable */

import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from '@fullcalendar/list';
import '@mdi/font/css/materialdesignicons.min.css';
import { getAuthCookie } from "../../utils/authCookies";

const SignageCalendar = () => {
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState<string | null>(null);
  const token = getAuthCookie("sessionToken");
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedEvent, setSelectedEvent] = useState<any>(null);

  const events = [
    {
      id: '1',
      title: 'World Braille Day',
      start: '2022-01-04',
      className: 'bg-info-subtle',
      allDay: true
    },
    {
      id: '2',
      title: 'World Leprosy Day',
      start: '2022-01-30',
      className: 'bg-info-subtle',
      allDay: true
    },
    {
      id: '3',
      title: 'International Mother Language Day',
      start: '2022-02-21',
      className: 'bg-info-subtle',
      allDay: true
    },
    {
      id: '4',
      title: "International Women's Day",
      start: '2022-03-08',
      className: 'bg-info-subtle',
      allDay: true
    },
    {
      id: '5',
      title: 'World Thinking Day',
      start: '2022-02-22',
      className: 'bg-info-subtle',
      allDay: true
    },
    {
      id: '6',
      title: 'International Mother Language Day',
      start: '2022-03-21',
      className: 'bg-info-subtle',
      allDay: true
    },
    {
      id: '7',
      title: 'World Water Day',
      start: '2022-03-22',
      className: 'bg-info-subtle',
      allDay: true
    },
    {
      id: '8',
      title: 'World Health Day',
      start: '2022-04-07',
      className: 'bg-info-subtle',
      allDay: true
    },
    {
      id: '9',
      title: 'International Special Librarians Day',
      start: '2022-04-16',
      className: 'bg-info-subtle',
      allDay: true
    },
    {
      id: '10',
      title: 'Earth Day',
      start: '2022-04-22',
      className: 'bg-info-subtle',
      allDay: true
    },
    {
      id: '153',
      title: 'All Day Event',
      start: '2025-04-01',
      className: 'bg-primary-subtle',
      location: 'San Francisco, US',
      allDay: true,
      extendedProps: { 'department': 'All Day Event' },
      description: 'An all-day event is an event that lasts an entire day or longer'
    },
    {
      id: '136',
      title: 'Visit Online Course',
      start: '2025-03-27',
      end: '2025-03-30',
      allDay: true,
      className: 'bg-warning-subtle',
      extendedProps: { 'department': 'Long Event' },
      description: 'Long Term Event means an incident that last longer than 12 hours.'
    },
    {
      id: '999',
      title: 'Visit Online Course',
      start: '2025-04-16T20:00',
      end: '2025-04-18T16:00',
      allDay: true,
      className: 'bg-warning-subtle',
      location: 'California, US',
      extendedProps: { 'department': 'Meeting with Alexis' },
      description: 'A meeting is a gathering of two or more people that has been convened for the purpose of achieving a common goal through verbal interaction, such as sharing information or reaching agreement.'
    },
    {
      id: '991',
      title: 'Repeating Event',
      start: '2025-04-25T16:00',
      end: '2025-04-29T16:00',
      allDay: true,
      className: 'bg-primary-subtle',
      location: 'Las Vegas, US',
      extendedProps: { 'department': 'Repeating Event' },
      description: 'A recurring or repeating event is simply any event that you will occur more than once on your calendar.'
    },
    {
      id: '112',
      title: 'Meeting With Designer',
      start: '2025-04-21T12:30',
      allDay: true,
      className: 'bg-success-subtle',
      location: 'Head Office, US',
      extendedProps: { 'department': 'Meeting' },
      description: 'Tell how to boost website traffic'
    },
    {
      id: '113',
      title: 'Weekly Strategy Planning',
      start: '2025-04-30',
      end: '2025-05-02',
      allDay: true,
      className: 'bg-danger-subtle',
      location: 'Head Office, US',
      extendedProps: { 'department': 'Lunch' },
      description: 'Strategies for Creating Your Weekly Schedule'
    },
    {
      id: '875',
      title: 'Birthday Party',
      start: '2025-04-22T19:00',
      allDay: true,
      className: 'bg-success-subtle',
      location: 'Los Angeles, US',
      extendedProps: { 'department': 'Birthday Party' },
      description: 'Family slumber party – Bring out the blankets and pillows and have a family slumber party! Play silly party games, share special snacks and wind down the fun with a special movie.'
    },
    {
      id: '783',
      title: 'Click for Google',
      start: '2025-04-28',
      end: '2025-04-29',
      allDay: true,
      url: 'http://google.com/',
      className: 'bg-dark-subtle'
    },
    {
      id: '456',
      title: 'Velzon Project Discussion with Team',
      start: '2025-04-14T20:00',
      end: '2025-04-15T16:00',
      allDay: true,
      className: 'bg-info-subtle',
      location: 'Head Office, US',
      extendedProps: { 'department': 'Discussion' },
      description: 'Tell how to boost website traffic'
    }
  ];

  const formatDateRange = (start: string, end?: string): string => {
    const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'short', year: 'numeric' };
    const startDate = new Date(start);
    const endDate = end ? new Date(end) : null;

    const formattedStart = startDate.toLocaleDateString("en-GB", options);

    if (endDate && endDate.toDateString() !== startDate.toDateString()) {
      const formattedEnd = endDate.toLocaleDateString("en-GB", options);
      return `${formattedStart} to ${formattedEnd}`;
    }

    return formattedStart;
  };


  return (
    <div className="content">
      <div className="card">
        <div className="card-body">
          <h2>Calendar</h2>
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-xl-3">
                  <div className="card card-h-100">
                    <div className="card-body">
                      <button className="btn btn-primary w-100" id="btn-new-event">
                        <i className="mdi mdi-plus"></i> Create New Event
                      </button>

                      <div id="external-events">
                        <br />
                        <p className="text-muted">Drag and drop your event or click in the calendar</p>
                        <div className="external-event fc-event bg-success-subtle text-success" data-className="bg-success-subtle">
                          <i className="mdi mdi-checkbox-blank-circle me-2"></i>New Event Planning
                        </div>
                        <div className="external-event fc-event bg-info-subtle text-info" data-className="bg-info-subtle">
                          <i className="mdi mdi-checkbox-blank-circle me-2"></i>Meeting
                        </div>
                        <div className="external-event fc-event bg-warning-subtle text-warning" data-className="bg-warning-subtle">
                          <i className="mdi mdi-checkbox-blank-circle me-2"></i>Generating Reports
                        </div>
                        <div className="external-event fc-event bg-danger-subtle text-danger" data-className="bg-danger-subtle">
                          <i className="mdi mdi-checkbox-blank-circle me-2"></i>Create New Theme
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h5 className="mb-1">Upcoming Events</h5>
                    <p className="text-muted">Don't miss scheduled events</p>
                    <div className="pe-2 me-n1 mb-3" data-simplebar style={{ height: "400px" }}>
                      <div id="upcoming-event-list">
                        {events?.map((event) => (
                          <div className="card mb-3">
                            <div className="card-body">
                              <div className="d-flex mb-3">
                                <div className="flex-grow-1">
                                  <i className="mdi mdi-checkbox-blank-circle me-2 text-danger"></i>
                                  <span className="fw-medium">{formatDateRange(event.start, event.end)} </span>
                                </div>
                                <div className="flex-shrink-0">
                                  <small className="badge bg-primary-subtle text-primary ms-auto">Full day event</small>
                                </div>
                              </div>
                              <h6 className="card-title fs-16"> {event?.title}</h6>
                              <p className="text-muted text-truncate-two-lines mb-0"> Strategies for Creating Your Weekly Schedule</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-body bg-info-subtle">
                      <div className="d-flex">
                        <div className="flex-shrink-0">
                          <i data-feather="calendar" className="text-info icon-dual-info"></i>
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <h6 className="fs-15">Welcome to your Calendar!</h6>
                          <p className="text-muted mb-0">
                            Event that applications book will appear here. Click on an event to see the details and manage applicants event.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-9">
                  <div className="card card-h-100">
                    <div className="card-body">
                      <FullCalendar
                        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]}
                        initialView="dayGridMonth"
                        headerToolbar={{
                          left: "prev,next,today",
                          center: "title",
                          right: "dayGridMonth,timeGridWeek,timeGridDay,listMonth"
                        }}
                        editable={true}
                        selectable={true}
                        events={events}
                        eventDisplay="block"
                        eventClick={(info) => setSelectedEvent(info.event)}
                      />

                    </div>
                  </div>
                </div>
              </div>
              <div style={{ clear: "both" }}></div>
            </div>
          </div>
          {selectedEvent && (
              <div className="modal fade show d-block" tabIndex={-1} style={{ background: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog" style={{ maxWidth: 450 }}>
                  <div className="modal-content border-0 rounded-3 shadow">
                    <div className="modal-header bg-primary-subtle text-primary">
                      <h5 className="modal-title">{selectedEvent.title}</h5>
                      <button type="button" className="btn-close" onClick={() => setSelectedEvent(null)}></button>
                    </div>
                    <div className="modal-body">
                      <ul className="list-unstyled mb-4">
                        <li className="mb-3 d-flex align-items-start">
                          <i className="mdi mdi-calendar-outline fs-5 me-2"></i>
                          <span>{formatDateRange(selectedEvent.startStr, selectedEvent.endStr)}</span>
                        </li>
                        <li className="mb-3 d-flex align-items-start">
                          <i className="mdi mdi-clock-outline fs-5 me-2"></i>
                          <span>-</span>
                        </li>
                        <li className="mb-3 d-flex align-items-start">
                          <i className="mdi mdi-map-marker-outline fs-5 me-2"></i>
                          <span><strong>{selectedEvent.extendedProps?.location || "No Location"}</strong></span>
                        </li>
                        <li className="d-flex align-items-start">
                          <i className="mdi mdi-comment-text-outline fs-5 me-2"></i>
                          <span>{selectedEvent.extendedProps?.description || "No description provided."}</span>
                        </li>
                      </ul>
                      <div className="d-flex justify-content-between align-items-center">
                        <button className="btn btn-sm btn-soft-primary">Edit</button>
                        <button className="btn btn-sm btn-soft-danger">× Delete</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}


        </div>
      </div>
    </div>
  );
};

export default SignageCalendar;
